import { useTranslation } from 'react-i18next';

import { Alert } from '@/components/atoms/Alert';

import type { AssignOffer, RemoveOffer } from '../../helpers/stockingAssignment';

/** Why a lineage's stocking can't be changed from the board, in the backend's own words. */
export default function LineageRefusal({ offer }: { offer: AssignOffer | RemoveOffer | null }) {
    const { t } = useTranslation('fishGroups');
    if (offer?.kind === 'blocked') {
        return (
            <Alert tone="danger" size="small">
                {offer.blocker === 'spansClients'
                    ? t('actions.errors.codes.lineageSpansClients')
                    : t('actions.errors.codes.lineageSpansSites')}
            </Alert>
        );
    }
    if (offer?.kind === 'severalStockings') {
        return (
            <Alert tone="danger" size="small">
                {t('stockingAssignment.lineage.severalStockings', {
                    names: offer.names.join(', '),
                })}
            </Alert>
        );
    }
    return null;
}
